module.exports = __webpack_public_path__ + "static/img/230825_BB_PineappleTangerine_Smiley_Anim01_1.4e734f7.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/230825_BB_PineappleTangerine_Smiley_Anim01_1.gif
// module id = fhjj
// module chunks = 0